import React from 'react';

const intro = (props) => {
  return (
    <section id='intro' className='welcome'>
      <div className='wrap'>
        <h2>Hi, there!</h2>
        <h4>To help us find the best health plan for {props.type},<br /> please answer a few quick questions.</h4>
      </div>
    </section>
  );
};

export default intro;
